import React from 'react';
import { useState, useEffect } from 'react';

import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';

import { Card, CardHeader, CardContent, CardActions, Typography } from '@mui/material';
import { Stack } from '@mui/material';


import MyDatePicker from 'components/Shared/MyDatePicker';
import LoadingButton from 'components/Shared/LoadingButton';


export default function ConfirmationReceptionFournisseur({ onClickSave, isAdding }) {


    const [date, setDate] = useState(null);
    const [memo, setMemo] = useState('');
    const [validationNOk, setValidationNOk] = useState(true);

    const [open, setOpen] = useState(false);

    useEffect(() => {
        setValidationNOk(!date || !memo);
    }, [date, memo]);

    return (

        <>

            <div hidden={open || isAdding}>
                <Button onClick={() => { setOpen(true); }} color="secondary" variant="contained" >Confirmation de réception par le fournisseur</Button>
            </div>


            {(open || isAdding) && (
                

                <Card>
                    <CardHeader
                        title={<Typography variant="body1">Confirmation de réception par le fournisseur</Typography>}
                        />

                    <CardContent>

                        <Stack spacing={1}>
                            <MyDatePicker
                                label="Date de confirmation"
                                value={date}
                                onChange={value => setDate(value)}
                                disableFuture={true}
                                required
                            />


                            <TextField
                                value={memo}
                                onChange={e => setMemo(e.target.value)}
                                label={"Mémo"}
                                multiline
                                fullWidth
                                required
                            />
                        </Stack>


                    </CardContent >


                    <CardActions sx={{justifyContent: 'right'}}>
                        <Button
                            onClick={() => { setOpen(false); }}
                            color="primary"
                            disabled={isAdding}
                        >
                            Annuler
                        </Button>
                        <LoadingButton
                            onClick={() => onClickSave(date, memo)}
                            label="Confirmer"
                            pending={isAdding}
                            disabled={validationNOk}
                        />
                    </CardActions>

                </Card>                
            )}
        </>
    );
}

